// import React, { useEffect, useState } from "react";
// import "./UserManagement.css";
// import baseURL from "../ApiUrl/Apiurl";
// import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
// import Swal from 'sweetalert2';

// const UserTable = ({ onAdd, onEdit  }) => {
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);

// useEffect(() => {
//   fetch(`${baseURL}/users/`)
//     .then((response) => {
//       if (!response.ok) throw new Error("Failed to fetch users");
//       return response.json();
//     })
//     .then((data) => {
//       // Filter only required roles
//       const filteredRoles = data.filter(user =>
//         ["Service Manager", "Service Engineer", "Customer"].includes(user.role)
//       );

//       // Sort by created_at in descending order
//       const sortedData = filteredRoles.sort(
//         (a, b) => new Date(b.created_at) - new Date(a.created_at)
//       );

//       setUsers(sortedData);
//       setFilteredUsers(sortedData);
//     })
//     .catch((error) => {
//       console.error("Error fetching user data:", error);
//     });
// }, []);


//   useEffect(() => {
//     const filtered = users.filter((user) =>
//       Object.values(user)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     );
//     setFilteredUsers(filtered);
//     setCurrentPage(1); // Reset to first page on search
//   }, [searchTerm, users]);



//     const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = (date.getMonth() + 1).toString().padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   const handleDelete = async (userId) => {
//     const confirmed = await Swal.fire({
//       title: "Are you sure?",
//       text: `You are about to delete user ID: ${userId}`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (confirmed.isConfirmed) {
//       try {
//         const response = await fetch(`${baseURL}/users/${userId}/`, {
//           method: "DELETE",
//         });

//         if (!response.ok) throw new Error("Delete failed");

//         Swal.fire("Deleted!", "User has been deleted.", "success");

//         const updatedUsers = users.filter((u) => u.user_id !== userId);
//         setUsers(updatedUsers);
//         setFilteredUsers(updatedUsers);
//       } catch (error) {
//         console.error("Delete error:", error);
//         Swal.fire("Error", "Failed to delete user", "error");
//       }
//     }
//   };

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredUsers.length / entriesPerPage);

//   return (
//     <div className="user-management-container">
//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
//         <div>
//           <h2 className="user-management-title mb-0">User Management</h2>
//           <p className="user-management-subtitle mb-0 text-muted">Manage user records</p>
//         </div>
//         <button onClick={onAdd} className="btn btn-primary">
//           Add New User
//         </button>
//       </div>

//       {/* Controls */}
//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <div className="d-flex align-items-center gap-2">
//           Show
//           <select
//             value={entriesPerPage}
//             onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//             className="form-select form-select-sm w-auto"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//           </select>
//           entries
//         </div>

//         <input
//           type="text"
//           placeholder="Search users..."
//           className="form-control w-auto"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       {/* Table */}
//       <div className="table-responsive mb-4">
//         <table className="table ">
//           <thead className="product-table-header">
//             <tr>
//               <th>S.No</th>
//               <th>User ID</th>
//               <th>Full Name</th>
//               <th>Username</th>
//               <th>Email</th>
//               <th>Mobile No.</th>
//               <th>Telephone</th>
//               <th>City</th>
//               <th>Country</th>
//               <th>Status</th>
//               <th>Role</th>
//               <th>Default Company</th>
//               <th>Accessible Companies</th>
//               <th>Created At</th>
//                  <th>Actions</th> 
//             </tr>
//           </thead>
//           <tbody>
//             {currentUsers.length > 0 ? (
//               currentUsers.map((user, index) => (
//                 <tr key={index}>
//                   <td>{indexOfFirstEntry + index + 1}</td>
//                   <td>{user.user_id}</td>
//                   <td>{user.full_name}</td>
//                   <td>{user.username}</td>
//                   <td>{user.email}</td>
//                   <td>{user.mobile}</td>
//                   <td>{user.telephone}</td>
//                   <td>{user.city}</td>
//                   <td>{user.country_code}</td>
//                   <td>
//                     <span className={`badge ${
//                       user.status === 'Active' ? 'bg-success' :
//                       user.status === 'Inactive' ? 'bg-warning text-dark' :
//                       'bg-danger'
//                     }`}>
//                       {user.status}
//                     </span>
//                   </td>
//                   <td>{user.role}</td>
//                   <td>{user.default_company}</td>
//                  <td>{Array.isArray(user.companies) ? user.companies.join(", ") : user.companies}</td>
//                   <td>{formatDate(new Date(user.created_at).toLocaleString())}</td>
//                   <td>
//   <div className="action-icons">
   
//    <FaEdit
//   title="Edit"
//   onClick={() => onEdit(user)}
//   className="action-icon edit-icon"
// />
// <FaTrash
//   title="Delete"
//   onClick={() => handleDelete(user.user_id)}
//   className="action-icon delete-icon"
// />
//   </div>
// </td>

//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="13" className="text-center">No users found.</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="pagination-controls d-flex justify-content-center mt-3">
//         <button
//           className="btn btn-outline-primary me-2"
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((prev) => prev - 1)}
//         >
//           Previous
//         </button>
//         <span className="align-self-center mx-2">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="btn btn-outline-primary ms-2"
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((prev) => prev + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default UserTable;


// import React, { useEffect, useState } from "react";
// import "./UserManagement.css";
// import baseURL from "../ApiUrl/Apiurl";
// import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
// import Swal from 'sweetalert2';

// const UserTable = ({ onAdd, onEdit  }) => {
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [companiesData, setCompaniesData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Fetch companies data
//   const fetchCompanies = async () => {
//     try {
//       const response = await fetch(`${baseURL}/companies/`);
//       const data = await response.json();
//       if (data.status === "success") {
//         setCompaniesData(data.data);
//       }
//     } catch (error) {
//       console.error("Failed to load companies data", error);
//     }
//   };

//   // Function to get company name only (hide ID)
//   const getCompanyName = (companyId) => {
//     if (!companiesData || companiesData.length === 0) return companyId;
    
//     const company = companiesData.find(comp => comp.company_id === companyId);
//     return company ? company.company_name : companyId;
//   };

//   // Function to get accessible companies names only
//   const getAccessibleCompaniesDisplay = (companyIds) => {
//     if (!companyIds || !Array.isArray(companyIds)) return '-';
    
//     if (companiesData.length === 0) {
//       return companyIds.join(", ");
//     }
    
//     return companyIds.map(companyId => getCompanyName(companyId)).join(", ");
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
      
//       // Fetch companies first
//       await fetchCompanies();
      
//       // Then fetch users
//       try {
//         const response = await fetch(`${baseURL}/users/`);
//         if (!response.ok) throw new Error("Failed to fetch users");
//         const data = await response.json();
        
//         // Filter only required roles
//         const filteredRoles = data.filter(user =>
//           ["Service Manager", "Service Engineer", "Customer"].includes(user.role)
//         );

//         // Sort by created_at in descending order
//         const sortedData = filteredRoles.sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );

//         setUsers(sortedData);
//         setFilteredUsers(sortedData);
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     const filtered = users.filter((user) =>
//       Object.values(user)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     );
//     setFilteredUsers(filtered);
//     setCurrentPage(1); // Reset to first page on search
//   }, [searchTerm, users]);

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = (date.getMonth() + 1).toString().padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   const handleDelete = async (userId) => {
//     const confirmed = await Swal.fire({
//       title: "Are you sure?",
//       text: `You are about to delete user ID: ${userId}`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     });

//     if (confirmed.isConfirmed) {
//       try {
//         const response = await fetch(`${baseURL}/users/${userId}/`, {
//           method: "DELETE",
//         });

//         if (!response.ok) throw new Error("Delete failed");

//         Swal.fire("Deleted!", "User has been deleted.", "success");

//         const updatedUsers = users.filter((u) => u.user_id !== userId);
//         setUsers(updatedUsers);
//         setFilteredUsers(updatedUsers);
//       } catch (error) {
//         console.error("Delete error:", error);
//         Swal.fire("Error", "Failed to delete user", "error");
//       }
//     }
//   };

//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(filteredUsers.length / entriesPerPage);

//   if (loading) {
//     return (
//       <div className="user-management-container">
//         <div className="text-center my-4">Loading users and companies...</div>
//       </div>
//     );
//   }

//   return (
//     <div className="user-management-container">
//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
//         <div>
//           <h2 className="user-management-title mb-0">User Management</h2>
//           <p className="user-management-subtitle mb-0 text-muted">Manage user records</p>
//         </div>
//         <button onClick={onAdd} className="btn btn-primary">
//           Add New User
//         </button>
//       </div>

//       {/* Controls */}
//       <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
//         <div className="d-flex align-items-center gap-2">
//           Show
//           <select
//             value={entriesPerPage}
//             onChange={(e) => setEntriesPerPage(Number(e.target.value))}
//             className="form-select form-select-sm w-auto"
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//           </select>
//           entries
//         </div>

//         <input
//           type="text"
//           placeholder="Search users..."
//           className="form-control w-auto"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       {/* Table */}
//       <div className="table-responsive mb-4">
//         <table className="table">
//           <thead className="product-table-header">
//             <tr>
//               <th>S.No</th>
//               <th>User ID</th>
//               <th>Full Name</th>
//               <th>Username</th>
//               <th>Email</th>
//               <th>Mobile No.</th>
//               <th>Telephone</th>
//               <th>City</th>
//               <th>Country</th>
//               <th>Status</th>
//               <th>Role</th>
//               <th>Default Company</th>
//               <th>Accessible Companies</th>
//               <th>Created At</th>
//               <th>Actions</th> 
//             </tr>
//           </thead>
//           <tbody>
//             {currentUsers.length > 0 ? (
//               currentUsers.map((user, index) => (
//                 <tr key={index}>
//                   <td>{indexOfFirstEntry + index + 1}</td>
//                   <td>{user.user_id}</td>
//                   <td>{user.full_name}</td>
//                   <td>{user.username}</td>
//                   <td>{user.email}</td>
//                   <td>{user.mobile}</td>
//                   <td>{user.telephone}</td>
//                   <td>{user.city}</td>
//                   <td>{user.country_code}</td>
//                   <td>
//                     <span className={`badge ${
//                       user.status === 'Active' ? 'bg-success' :
//                       user.status === 'Inactive' ? 'bg-warning text-dark' :
//                       'bg-danger'
//                     }`}>
//                       {user.status}
//                     </span>
//                   </td>
//                   <td>{user.role}</td>
//                   <td title={getCompanyName(user.default_company)}>
//                     {getCompanyName(user.default_company)}
//                   </td>
//                   <td title={getAccessibleCompaniesDisplay(user.companies)}>
//                     {getAccessibleCompaniesDisplay(user.companies)}
//                   </td>
//                   <td>{formatDate(user.created_at)}</td>
//                   <td>
//                     <div className="action-icons">
//                       <FaEdit
//                         title="Edit"
//                         onClick={() => onEdit(user)}
//                         className="action-icon edit-icon"
//                       />
//                       <FaTrash
//                         title="Delete"
//                         onClick={() => handleDelete(user.user_id)}
//                         className="action-icon delete-icon"
//                       />
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="15" className="text-center">
//                   {searchTerm ? 'No users found matching your search' : 'No users found'}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="pagination-controls d-flex justify-content-center mt-3">
//         <button
//           className="btn btn-outline-primary me-2"
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((prev) => prev - 1)}
//         >
//           Previous
//         </button>
//         <span className="align-self-center mx-2">
//           Page {currentPage} of {totalPages}
//         </span>
//         <button
//           className="btn btn-outline-primary ms-2"
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((prev) => prev + 1)}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default UserTable;

//===============================================================
// After fixing filter -Global search issue 


import React, { useEffect, useState, useRef } from "react";
import "./UserManagement.css";
import baseURL from "../ApiUrl/Apiurl";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import { FaKey } from "react-icons/fa";

const UserTable = ({ onAdd, onEdit }) => {
  const [users, setUsers] = useState([]);
  const [companiesData, setCompaniesData] = useState([]);
  const [resources, setResources] = useState([]);
  const [servicePools, setServicePools] = useState([]);
  
  const [searchTerm, setSearchTerm] = useState(() => {
    return sessionStorage.getItem('users_searchTerm') || '';
  });
  const [entriesPerPage, setEntriesPerPage] = useState(() => {
    return Number(sessionStorage.getItem('users_entriesPerPage')) || 5;
  });
  const [currentPage, setCurrentPage] = useState(() => {
    return Number(sessionStorage.getItem('users_currentPage')) || 1;
  });
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [resourcesLoading, setResourcesLoading] = useState(false);
  const [error, setError] = useState(null);

  const userId = localStorage.getItem("userId");
  const companyId = localStorage.getItem("selectedCompany");
  const navigate = useNavigate();

  // Refs for managing requests
  const abortControllerRef = useRef(null);
  const initialLoadRef = useRef(true);

  // Session storage effects
  useEffect(() => {
    sessionStorage.setItem('users_searchTerm', searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    sessionStorage.setItem('users_entriesPerPage', entriesPerPage);
  }, [entriesPerPage]);

  useEffect(() => {
    sessionStorage.setItem('users_currentPage', currentPage);
  }, [currentPage]);

  // Fetch companies data
  const fetchCompanies = async () => {
    try {
      const response = await fetch(`${baseURL}/companies/`);
      const data = await response.json();
      if (data.status === "success") {
        setCompaniesData(data.data);
      }
    } catch (error) {
      console.error("Failed to load companies data", error);
    }
  };

  // Fetch resources data with pagination
  const fetchResources = async () => {
    setResourcesLoading(true);
    try {
      let allResources = [];
      let page = 1;
      let hasNext = true;

      while (hasNext) {
        const response = await fetch(
          `${baseURL}/resources-pagination/?user_id=${userId}&company_id=${companyId}&page=${page}&page_size=100`
        );
        const data = await response.json();
        
        if (data.status === "success") {
          const pageItems = Array.isArray(data.data) ? data.data : [];
          allResources = allResources.concat(pageItems);
          
          const pagination = data.pagination;
          if (pagination && pagination.has_next && pagination.next_page) {
            page = pagination.next_page;
            hasNext = true;
          } else {
            hasNext = false;
          }
        } else {
          hasNext = false;
        }
      }
      
      setResources(allResources);
    } catch (error) {
      console.error("Failed to load resources data", error);
    } finally {
      setResourcesLoading(false);
    }
  };

  // Fetch service pools data with pagination
  const fetchServicePools = async () => {
    try {
      let allServicePools = [];
      let page = 1;
      let hasNext = true;

      while (hasNext) {
        const response = await fetch(
          `${baseURL}/service-pools-pagination/?user_id=${userId}&company_id=${companyId}&page=${page}&page_size=100`
        );
        const data = await response.json();
        
        if (data.status === "success") {
          const pageItems = Array.isArray(data.data) ? data.data : [];
          allServicePools = allServicePools.concat(pageItems);
          
          const pagination = data.pagination;
          if (pagination && pagination.has_next && pagination.next_page) {
            page = pagination.next_page;
            hasNext = true;
          } else {
            hasNext = false;
          }
        } else {
          hasNext = false;
        }
      }
      
      setServicePools(allServicePools);
    } catch (error) {
      console.error("Failed to load service pool data", error);
    }
  };

  // Fetch users data with pagination
  const fetchUsers = async (page = currentPage, size = entriesPerPage, search = searchTerm, isInitial = false) => {
    // Cancel previous request if any
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    if (isInitial) {
      setLoading(true);
    } else {
      setFetching(true);
    }
    setError(null);

    abortControllerRef.current = new AbortController();

    try {
      let url = `${baseURL}/users-pagination/?page=${page}&page_size=${size}`;
      
      if (search.trim()) {
        url += `&search_query=${encodeURIComponent(search.trim())}`;
      }

      const response = await fetch(url, {
        signal: abortControllerRef.current.signal
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Filter only required roles
      const filteredRoles = data.data.filter(user =>
        ["Service Manager", "Service Engineer", "Customer"].includes(user.role)
      );

      // Sort by created_at in descending order (newest first)
      const sortedData = filteredRoles.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setUsers(sortedData);
      setError(null);

      // Update pagination info
      const pagination = data.pagination || {};
      setTotalCount(pagination.total_count || 0);
      setTotalPages(pagination.total_pages || 1);
      setHasNextPage(pagination.has_next || false);
      setCurrentPage(pagination.current_page || 1);
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }
      console.error("Error fetching user data:", error);
      setError(error.message || 'Failed to fetch users');
      setUsers([]);
    } finally {
      if (isInitial) {
        setLoading(false);
      } else {
        setFetching(false);
      }
      abortControllerRef.current = null;
    }
  };

  // Initial load - fetch all data
  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchCompanies(),
          fetchResources(),
          fetchServicePools(),
          fetchUsers(1, entriesPerPage, '', true)
        ]);
      } catch (error) {
        console.error("Error loading initial data:", error);
        setError('Failed to load initial data');
      } finally {
        setLoading(false);
        initialLoadRef.current = false;
      }
    };

    loadInitialData();

    // Cleanup
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  // Handle search and entries per page changes
  useEffect(() => {
    if (initialLoadRef.current) return;

    const debounceTimer = setTimeout(() => {
      fetchUsers(1, entriesPerPage, searchTerm, false);
    }, 300);

    return () => {
      clearTimeout(debounceTimer);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [searchTerm, entriesPerPage]);

  // Handle page changes
  useEffect(() => {
    if (initialLoadRef.current) return;

    fetchUsers(currentPage, entriesPerPage, searchTerm, false);
  }, [currentPage]);

  // Function to get company name only (hide ID)
  const getCompanyName = (companyId) => {
    if (!companiesData || companiesData.length === 0) return companyId;
    
    const company = companiesData.find(comp => comp.company_id === companyId);
    return company ? company.company_name : companyId;
  };

  // Function to format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getResourceId = (userId) => {
    if (!resources || resources.length === 0) return "-";

    const resource = resources.find(res => res.user === userId);
    return resource ? resource.resource_id : "-";
  };

  const isEngineerActive = (user) => {
    // Only apply for Service Engineer
    if (user.role !== "Service Engineer") return false;

    const resourceId = getResourceId(user.user_id);
    if (!resourceId || resourceId === "-") return false;

    // Get all requests assigned to this engineer
    const assignedRequests = servicePools.filter(
      (req) => req.assigned_engineer === resourceId
    );

    if (assignedRequests.length === 0) return false;

    // Check if ANY request is NOT closed
    const hasActiveRequest = assignedRequests.some(
      (req) => req.status !== "Closed"
    );

    return hasActiveRequest; // true = disable delete
  };

  const handleDelete = async (user) => {
    const isActive = isEngineerActive(user);

    // Block delete if engineer is active
    if (isActive) {
      Swal.fire({
        icon: "warning",
        title: "Action Not Allowed",
        text: "This engineer is currently assigned to active service requests. You cannot delete this user.",
        confirmButtonColor: "#d33",
      });
      return;
    }

    // Normal delete flow
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete user ID: ${user.user_id}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      try {
        const response = await fetch(`${baseURL}/users/${user.user_id}/`, {
          method: "DELETE",
        });

        if (!response.ok) throw new Error("Delete failed");

        Swal.fire("Deleted!", "User has been deleted.", "success");

        // Refresh current page
        fetchUsers(currentPage, entriesPerPage, searchTerm, false);
      } catch (error) {
        console.error("Delete error:", error);
        Swal.fire("Error", "Failed to delete user", "error");
      }
    }
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
    sessionStorage.setItem('users_currentPage', 1);
  };

  const handleEntriesPerPageChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
    sessionStorage.setItem('users_currentPage', 1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleResetPassword = (user) => {
    navigate(`/admin/users/${user.user_id}/reset-password`, {
      state: {
        user,
        companyId,
        userId,
      },
    });
  };

  const indexOfFirstEntry = (currentPage - 1) * entriesPerPage;
  const currentUsers = users;

  if (loading || resourcesLoading) {
    return (
      <div className="user-management-container">
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p>Loading {loading ? 'users' : 'resources'}...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="user-management-container">
        <div className="alert alert-danger my-4">
          {error}
          <button 
            className="btn btn-primary ms-3" 
            onClick={() => fetchUsers(currentPage, entriesPerPage, searchTerm, false)}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management-container">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <div>
          <h2 className="user-management-title mb-0">User Management</h2>
          <p className="user-management-subtitle mb-0 text-muted">Manage user records</p>
        </div>
        <button onClick={onAdd} className="btn btn-primary">
          Add New User
        </button>
      </div>

      {/* Controls */}
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <div className="d-flex align-items-center gap-2">
          Show
          <select
            value={entriesPerPage}
            onChange={(e) => handleEntriesPerPageChange(Number(e.target.value))}
            className="form-select form-select-sm w-auto"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
          entries
        </div>

        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            placeholder="Search in all columns..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => handleSearchChange(e.target.value)}
            style={{ minWidth: '250px' }}
          />
          {searchTerm && (
            <button 
              className="btn btn-sm btn-outline-secondary"
              onClick={() => handleSearchChange('')}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      {/* Results Summary */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          {searchTerm && (
            <div className="alert alert-info mb-0">
              <strong>Search Results:</strong> Found {totalCount} user(s) matching "{searchTerm}"
            </div>
          )}
        </div>
        <div className="text-muted small">
          Showing {currentUsers.length} of {totalCount} users
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive mb-4">
        <table className="table">
          <thead className="product-table-header">
            <tr>
              <th>S.No</th>
              <th>User ID</th>
              <th>Resource ID</th>
              <th>Full Name</th>
              <th>Username</th>
              <th>Email</th>
              <th>Mobile No.</th>
              <th>Telephone</th>
              <th>City</th>
              <th>Country</th>
              <th>Status</th>
              <th>Role</th>
              <th>Reset Password</th>
              <th>Default Company</th>
              <th>Accessible Companies</th>
              <th>Created At</th>
              <th>Actions</th> 
            </tr>
          </thead>
          <tbody>
            {fetching ? (
              <tr>
                <td colSpan="17" className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2 mb-0 text-muted">Loading users...</p>
                </td>
              </tr>
            ) : currentUsers.length > 0 ? (
              currentUsers.map((user, index) => (
                <tr key={user.user_id || index}>
                  <td>{indexOfFirstEntry + index + 1}</td>
                  <td>{user.user_id}</td>
                  <td>
                    {user.role === "Service Engineer"
                      ? getResourceId(user.user_id)
                      : "-"}
                  </td>
                  <td>{user.full_name}</td>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.mobile}</td>
                  <td>{user.telephone}</td>
                  <td>{user.city}</td>
                  <td>{user.country_code}</td>
                  <td>
                    <span className={`badge ${
                      user.status === 'Active' ? 'bg-success' :
                      user.status === 'Inactive' ? 'bg-warning text-dark' :
                      'bg-danger'
                    }`}>
                      {user.status}
                    </span>
                  </td>
                  <td>{user.role}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                      onClick={() => handleResetPassword(user)}
                      title={`Reset password for ${user.username}`}
                    >
                      <FaKey size={12} />
                      Reset Password
                    </button>
                  </td>
                  <td title={getCompanyName(user.default_company)}>
                    {getCompanyName(user.default_company)}
                  </td>
                  <td title={user.companies ? user.companies.map(id => getCompanyName(id)).join(', ') : '-'}>
                    {user.companies ? user.companies.map(id => getCompanyName(id)).join(', ') : '-'}
                  </td>
                  <td>{formatDate(user.created_at)}</td>
                  <td>
                    <div className="action-icons">
                      <FaEdit
                        title="Edit"
                        onClick={() => onEdit(user)}
                        className="action-icon edit-icon"
                        style={{ cursor: 'pointer' }}
                      />
                      <FaTrash
                        title="Delete"
                        onClick={() => handleDelete(user)}
                        className="action-icon delete-icon"
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="17" className="text-center">
                  {searchTerm ? `No users found matching "${searchTerm}"` : 'No users found'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination-controls d-flex justify-content-center mt-3">
          <button
            className="btn btn-outline-primary me-2"
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            Previous
          </button>
          
          <div className="d-flex align-items-center mx-2">
            {(() => {
              const maxVisiblePages = 5;
              let pageNumbers = [];
              
              if (totalPages <= maxVisiblePages) {
                for (let i = 1; i <= totalPages; i++) {
                  pageNumbers.push(i);
                }
              } else {
                let startPage = Math.max(1, currentPage - 2);
                let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                
                if (endPage - startPage + 1 < maxVisiblePages) {
                  startPage = Math.max(1, endPage - maxVisiblePages + 1);
                }
                
                for (let i = startPage; i <= endPage; i++) {
                  pageNumbers.push(i);
                }
              }
              
              return pageNumbers.map((page) => (
                <button
                  key={page}
                  className={`btn mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              ));
            })()}
          </div>
          
          <span className="align-self-center mx-2">
            Page {currentPage} of {totalPages}
          </span>
          
          <button
            className="btn btn-outline-primary ms-2"
            disabled={!hasNextPage && currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default UserTable;